// extracted by mini-css-extract-plugin
export default {"wrapper":"Warning_wrapper__-NyqJ","title":"Warning_title__yg4wX"};